/**
 * LS Electric 통합챗봇 위젯 스크립트 삽입 훅.
 *
 * 지원 마켓: ko-KR(KR), en(GLOBAL), en-US(NA).
 * 페이지 로드당 1회 삽입 — 국가 전환(CountrySelect)은 풀 리로드이므로 런타임 market 변경 대응 불필요.
 * env(VITE_CHATBOT_*)가 비어 있으면 어떤 환경에서도 외부 요청이 발생하지 않는다.
 */
import React from 'react';

import svcs from 'services';
import { CHATBOT_RELEASE_DATE, injectChatbotWidget } from 'util/chatbotutil';
import { cookieutil } from 'util/cookieutil';
import { ssqutil } from 'util/ssqutil';

const useChatbotWidget = () => {
  React.useEffect(() => {
    const lang = svcs.svcLang.lang();
    injectChatbotWidget({
      url: import.meta.env.VITE_CHATBOT_WIDGET_URL,
      clientId: import.meta.env.VITE_CHATBOT_CLIENT_ID,
      lang,
      // 쿠키 동의 정책: "명시적 functionality 거부만 차단" (쿠키 미응답=허용, ko-KR 항상 허용)
      // — GTM 등 사이트 기존 정책과 동일. mount 시 1회 평가이므로 같은 페이지에서
      // 동의 상태를 바꾸면 다음 페이지 로드부터 반영된다.
      consented: cookieutil.isAcceptFunctionConsentCookie(lang),
      releaseDate: ssqutil.isProduction() ? CHATBOT_RELEASE_DATE : undefined,
    });
    // cleanup 없음 — script 태그를 제거해도 실행이 취소되지 않고, 재추가 시 재실행됨 (useScript.ts 참고)
  }, []);
};

export default useChatbotWidget;
